<div class="working-time-period-picker">
  <mat-slide-toggle
    class="working-time-period-picker__toggler mb-4"
    [checked]="showFinished()"
    (change)="showFinished.set($event.checked)">
    {{ 'ABS-ShowEndedWorkingTimePeriods' | translate }}
  </mat-slide-toggle>

  <mat-form-field appearance="outline" class="working-time-period-picker__select">
    <mat-label>{{ 'ABS-WorkingTimePeriod' | translate }}</mat-label>
    <mat-select [value]="periodSelection()" [compareWith]="comparePeriods" (selectionChange)="periodSelection.set($event.value)">
      @for (period of filteredPeriods(); track period.StartDate) {
      <mat-option [value]="period">
        {{ dateKey(period.StartDate) }}
        &nbsp;–&nbsp;
        @if (period.EndDate) {
        {{ dateKey(period.EndDate) }}
        } @else {
        {{ 'UndefinedTerm' | translate }}
        }
        &nbsp;|&nbsp;
        {{ period.WorkingTime }}
      </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
